import React, { Component } from 'react'
import './index.css'
// import logo from '../../images/logo.svg'
// import p_logo from '../../images/p_logo.svg'
import { Menu } from 'antd'
import menuIcon from '../../images/menu.svg'
import closeIcon from '../../images/close.svg'
import 'antd/dist/antd.css'
import { observable } from 'mobx'
import { observer } from 'mobx-react'

@observer
export default class Header extends Component {
  @observable menushow = false
  constructor() {
    super()
    this.state = {
      current: 'home',
    }
  }

  handleClick = (e) => {
    this.setState({
      current: e.key,
    });
  }
  
  handleShowMenu = () => {
    this.menushow = true
  }
  handleCloseMenu = () => {
    this.menushow = false
  }
  anchorToServer = () => {
    this.menushow = false
    document.getElementById("service").scrollIntoView();
  }
  anchorToAbout = () => {
    this.menushow = false
    document.getElementById("about").scrollIntoView();
  }
  anchorToJoin = () => {
    this.menushow = false
    document.getElementById("join").scrollIntoView();
  }
  anchorToHome = () => {
    this.menushow = false
  }

  
  render() {
    return (
      <div>
        <header className='header'>
          <div className='headerWrap'>
            <div className='logo'>
              嘉云升科技官方网站
            </div>
            <Menu 
              className='menuItem' 
              mode="horizontal" 
              style={{marginLeft: '157px'}}
              selectedKeys = {
                [this.state.current]
              }
              onClick={this.handleClick}
            >
              <Menu.Item 
                key="home"
              >
                <a>首页</a>
              </Menu.Item>
              <Menu.Item key="product">
                <a href='#service'>产品服务</a>
              </Menu.Item>
              <Menu.Item key="app">
                <a href='#about'>关于我们</a>
              </Menu.Item>
              <Menu.Item key="alipay">
               <a href='#join'>加入我们</a>
              </Menu.Item>
            </Menu>
          </div>
          <div className='p-headerWrap'>
            <div className='logo'>
              嘉云升科技官方网站
            </div>
            {!this.menushow && 
              <div 
                className='menuBtn' 
                onClick={this.handleShowMenu}
              >
                <img className='menuIcon' src={menuIcon} alt=''/>
              </div>
            }
            {this.menushow && 
            <div 
              className='menuBtn' 
              onClick={this.handleCloseMenu}
            >
              <img className='closeIcon' src={closeIcon} alt=''/>
            </div>}
          </div>
          {this.menushow && 
          <div className='wap_menu'>
            <ul>
              <li onClick={this.anchorToHome}>
                <a>首页</a>
              </li>
              <li onClick={this.anchorToServer}>
                <a>产品服务</a>
              </li>
              <li onClick={this.anchorToAbout}>
                <a>关于我们</a>
              </li>
              <li onClick={this.anchorToJoin}>
                <a>加入我们</a>
              </li>
            </ul>
          </div>}
        </header>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/Header/index.js